export default {
  title: '{{company}} ți-a actualizat ora de ridicare',
  title_on_site: '{{company}} a actualizat momentul în care este servită comanda ta',
  new_time_label: 'Ora nouă',
};
